import React from "react";
import "../styles/Footer.css"; // Import the external stylesheet

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          <p className="footer-text">
            &copy; {new Date().getFullYear()} Shubh Jiwan. All rights reserved.
            <br /> Design & Developed by © SaturnX Digital - All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
